import { IUpdateIbanEntity } from '../entitites/iban.entity';

export class IbanUpdateDto {
  readonly iban: string;
  readonly terms_agreement: boolean;

  constructor(entity: IUpdateIbanEntity) {
    this.iban = entity.iban;
    this.terms_agreement = true;
  }
}
